module.exports = __webpack_public_path__ + "img/ai-search-4.73075420.jpg";